import { useFeatureFlags } from "_shared/FeatureFlagsContext";
import { lazy } from "react";
const Survey = lazy(() => import("./Survey"));

export function StaticSurvey() {
  const { isStaticSurveyOn } = useFeatureFlags();
  if (!isStaticSurveyOn) throw new Error("404");
  return <Survey />;
}
